import { render } from "./deleteProgramsPopup.vue?vue&type=template&id=73927b5f&scoped=true"
import script from "./deleteProgramsPopup.vue?vue&type=script&lang=js"
export * from "./deleteProgramsPopup.vue?vue&type=script&lang=js"

import "./deleteProgramsPopup.vue?vue&type=style&index=0&id=73927b5f&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73927b5f"]])

export default __exports__